/**
 * Read-only "Ordering for: <contractor>" strip for contractor-scoped pages a
 * PC user reaches mid-flow (the photo/list flow, order editing) — places where
 * switching contractors would invalidate in-progress work, so unlike the
 * new-order banner there is no switcher. Renders nothing for contractor users
 * or when no contractor is bound.
 */

import { useTranslation } from "react-i18next";
import { Building2 } from "lucide-react";
import { usePcOrderScope } from "@/components/pc/PcOrderScopeProvider";

export function PcOrderingForBanner() {
  const { t } = useTranslation();
  const scope = usePcOrderScope();
  if (!scope?.contractor) return null;

  return (
    <div className="flex items-center gap-2 mt-3 px-3 py-2 rounded-md border bg-muted/50 text-sm lg:w-fit lg:max-w-full">
      <Building2 className="h-4 w-4 text-muted-foreground flex-shrink-0" />
      <span className="text-muted-foreground">
        {t("pages.pcNewOrder.orderingFor")}
      </span>
      <span className="font-medium truncate">{scope.contractor.name}</span>
    </div>
  );
}
